import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  toVerifyItems: null,
  verifiedItems: null
};

export const verifyFields = createSlice({
  name: 'verifyFields',
  initialState,
  reducers: {
    setToVerifyItems: (state, action: PayloadAction<any>) => {
      state.toVerifyItems = action.payload;
    },
    setVerifiedItems: (state, action: PayloadAction<any>) => {
      state.verifiedItems = action.payload;
    },
    clearVerifiedItems: state => {
      state.verifiedItems = null;
    }
  }
});

export const { setToVerifyItems, setVerifiedItems, clearVerifiedItems } = verifyFields.actions;
